module.exports = __webpack_public_path__ + "img/packaged.0614bdcf.png";